<template>
<div> 
    <v-card>
        <v-card-title :class="$style.Title" v-html="header"></v-card-title>

        <!-- <v-card-text :class="$style.vCard"> -->
        <div :class="$style.vCard">
            <v-form v-model="valid_form" ref="form">
                <div :class="$style.questions" v-html="body" />
                <div v-html="subtext"/>
                <v-row v-for="group in question.config.groups">
                    <template v-for="input in group.inputs">
                        <v-col md="4" lg="4" xl="4" cols="12" v-html="group.label[$language()]" :class="['cell_content', $style.tr, 'my-0', 'pl-6', 'pb-0', 'd-flex', 'align-center']"></v-col>
                        <v-col md="8" lg="8" xl="8" cols="12" :class="['cell_content', $style.tr, 'my-0', 'px-2', 'py-3']">
                            <StarRating  
                                v-model="value[group.id][input.id]"
                                :animate="true" 
                                :active-color="['#00A4C0','#00A4C0']" 
                                :active-border-color="['#F6546A','#a8c3c0']" 
                                :border-width="4" 
                                :star-points="[23,2, 14,17, 0,19, 10,34, 7,50, 23,43, 38,50, 36,34, 46,19, 31,17]" 
                                :active-on-click="true" 
                                :clearable="true" 
                                :padding="3"/>
                        </v-col>
                    </template>
                </v-row>
            </v-form>
        </div>

        <v-card-text v-html="footer">
        </v-card-text>
    </v-card>
</div>
</template>

<script>

import StarRating from 'vue-star-rating'

const controller = require("./controllers/rating.js").default;
const module_generator = require("./controllers/module_generator.js").default;

var module_config = module_generator('rating-question',controller);
module_config.methods.figureTableHeaderMaxWidth = function() {
    let min = 0;
    let minHeaderWidth = 50;
    let maxHeaderWidth = 350;
    let magicSpacing = 5;
    let inputs = this.question.config.groups[0].inputs;
    for(let i = 0; i < inputs.length; i++) {
        let input = inputs[i];
        let label = input.label[this.$language()];
        if(label.length > min) {
            min = label.length;
        }
    }
    return (min * magicSpacing) > maxHeaderWidth ? maxHeaderWidth : Math.max(minHeaderWidth, min * magicSpacing)
}

module_config.components = { StarRating }; 
export default module_config;


</script>

<style module>
.Title {
    font-size: 20px;
    margin: 0px 0px 0px 0px;
    font-weight: 500;
    word-break: break-word !important;
}

.Label {
    position: relative; 
    top: -5px;
    float: left;
    width: 25%;
    margin-right: 20px;
}

.vCard {
    margin: 0 auto;
    width: 95%;
}

.question{
    border: 1px solid slategray;
    border-radius: 3px;
    margin: 25px;
    padding: 15px;
}

.questions {
    font-size:18px; 
    color:black;
}



.groupLabel {
    padding: 0 15px;
    width: 50%;
}

.groupNoLabel {
    padding: 0;
    width: 0%;
}

.group {
    margin: 35px 0px 0px 0px;
}

.groupRadio {
    margin-bottom: 20px !important;
    margin-right: 0px !important;
}

.groupLabelMobile {
    font-size: 10px !important;
    padding: 5px !important;
    word-wrap: break-word;
}

.debug{
    display: inline-block;
    margin: 5px;
    color: darkred;
}

@media only screen and (max-width: 1240px) {
    .vCard {
        padding: 0 100px;
    }
}

@media only screen and (max-width: 1145px) {
    .vCard {
        padding: 0 80px;
    }
}

@media only screen and (max-width: 1105px) {
    .vCard {
        padding: 0 30px;
    }
}

@media only screen and (max-width: 1000px) {
    .vCard {
        padding: 0 10px;
    }
}

@media only screen and (max-width: 980px) {

.Title {
    font-size: 18px;
    margin: 25px 10px;
}

.questions {
    width: 95%;
}

.vCard {
    margin: 0px !important;
    width: 100%;
    padding: 0px;
}

.Label {
    position: relative; 
    top: 0px !important; 
    float:none;
    width: 90%;
}

.group {
    margin: 15px 0px;
}

.groupRadio {
    margin-bottom: 12px !important;
}
}
</style>

<style lang='css' scoped>
.heading {
    background-color: #5d6870;
    font-size: 1rem;
    color: white;
    word-wrap: break-word;
    border: 1px solid #e5e5e5;
}

.cell_content {
    border: 1px solid #e5e5e5;    
}

</style>

<style>
.vue-star-rating-rating-text {
    display: none;
}
</style>
